import baseTheme from "@insite/mobius/globals/baseTheme";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const colors: Styleguide["colors"] = {
    primary: {
        light: "#3c77d2",
        dark: "#1b3f76",
    },
    secondary: {
        light: "#90989f",
        dark: "#4c5258",
    },
    tertiary: {
        light: "#90989f",
        main: "#6c757d",
        contrast: "#ffffff",
        dark: "#4c5258",
    },
    common: {
        accentContrastLight: "#aaaaaa",
        borderLight: "#e6e6e6",
        borderDark: "#aaaaaa",
        disabledDark: "#cccccc",
    },
    text: {
        linkHover: "#1b3f76",
        linkAlt: "#0F0F0F",
        linkAltHover: "#275AA8",
        input: baseTheme.colors.text.main,
    },
    success: {
        light: "#d4eddb",
    },
    warning: {
        light: "#fff3cf",
    },
    danger: {
        light: "#fadcd3",
    },
    info: {
        light: "#d0ecf1",
    },
    neutral: {
        main: "#666666",
        contrast: "#ffffff",
        light: "#e0e0e0",
    },
    invert: {
        main: "#ffffff",
        contrast: "#0f0f0f",
        dark: "#ececec",
    },
    placeholder: {
        main: "#666666",
        disabled: baseTheme.colors.text.disabled,
    },
    button: {
        disabled: {
            main: baseTheme.colors.common.disabled,
            contrast: baseTheme.colors.text.disabled,
        },
    },
    header: {
        main: "#ffffff",
        contrast: "#0F0F0F",
        hover: "#1b3f76",
        accent: "#275AA8",
        accentHover: "#1b3f76",
        accentContrast: "#ffffff",
    },
    menu: {
        mainNavigation: {
            main: "#ffffff",
            contrast: "#0F0F0F",
            hover: "#275AA8",
            border: "#CCCCCC",
            accent: "#275AA8",
            accentHover: "#275AA8",
            accentContrast: "#ffffff",
        },
        secondaryNavigation: {
            main: "#275AA8",
            contrast: "#ffffff",
            hover: "#ffffff",
        },
    },
    footer: {
        main: "#F8F9FA",
        contrast: "#0F0F0F",
        alt: "#275AA8",
        altContrast: "#ffffff",
    },
    swatch: {
        main: "#CCCCCC",
        contrast: "#0F0F0F",
        hover: "#275AA8",
        selected: "#275AA8",
        selectedHover: "#1b3f76",
    },
};

export default colors;
